import React, { useContext, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import { SnackBarContext } from '../../../sharedModules/form/contexts/SnackBarContext';

interface UpdateExpectedDateModalProps {
  open: boolean;
  onClose: () => void;
  poNumber: string;
  currentExpected: string;
}

const UpdateExpectedDateModal: React.FC<UpdateExpectedDateModalProps> = ({
  open,
  onClose,
  poNumber,
  currentExpected,
}) => {
  const { showSuccessSnackBar } = useContext(SnackBarContext);
  const [expectedDate, setExpectedDate] = useState(currentExpected);
  const [comment, setComment] = useState('');

  const handleUpdate = () => {
    console.log('Mock update PO expected date:', { poNumber, expectedDate, comment });
    showSuccessSnackBar?.('Expected date updated (mock)');
    setComment('');
    onClose();
  };

  const handleClose = () => {
    setComment('');
    setExpectedDate(currentExpected);
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>Update Expected Date — {poNumber}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 0.5 }}>
          <Grid item xs={12}>
            <TextField
              label="Expected Date"
              type="date"
              value={expectedDate}
              onChange={(e) => setExpectedDate(e.target.value)}
              fullWidth
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Comment (optional)"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              fullWidth
              multiline
              rows={3}
              placeholder="Add a comment about this date change..."
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button onClick={handleUpdate} variant="contained" disabled={!expectedDate}>
          Update
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UpdateExpectedDateModal;
